<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-sm-10 col-md-10 col-lg-10 col-xl-9 col-xxl-7 col-12">
              <div class="d-flex align-items-center mb-2 indpg-tptxt">
                <h3>
                  <app-greeting></app-greeting>
                </h3>
              </div>
              <div class="row mx-0 py-2">
                <div
                  class="col-12 p-2 mb-3 right-notfctn"
                  *ngIf="userDashboardDetails?.announcements && userDashboardDetails?.announcements.length > 0"
                >
                  <img src="../../../assets/images/svg/notification-icon.svg" style="float: left" />
                  <span>Announcements</span>
                  <div class="announcement-carousel">
                    <div class="announcement-content">
                      <p
                        *ngFor="let announcement of visibleAnnouncements"
                        (click)="displayNotificationDetails(announcement)"
                        class="cursor pad-top-15"
                        [@slideIn]
                      >
                        <ng-container *ngIf="announcement.taskSubCategory">
                          [{{ announcement.taskSubCategory }}] -
                        </ng-container>
                        {{ announcement.heading }}
                      </p>
                    </div>

                    <div class="carousel-controls">
                      <button class="carousel-btn prev" (click)="prevAnnouncement()">
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button class="carousel-btn next" (click)="nextAnnouncement()">
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button class="carousel-btn pause-play" (click)="togglePausePlay()">
                        <i [ngClass]="isPaused ? 'fa fa-play' : 'fa fa-pause'"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-8 col-12 px-0 mb-3 right-clndr">
                  <div class="row text-center mx-0 cal-hed">
                    <div class="col-md-2 cal-hed-first">
                      <div class="btn-group">
                        <div
                          class="cursor"
                          mwlCalendarPreviousView
                          [view]="view"
                          [(viewDate)]="viewDate"
                          (viewDateChange)="closeOpenMonthViewDay()"
                        >
                          <img src="./assets/images/prev.png" class="img-fluid pre-next" />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 cal-hed-second">
                      <h3>{{ viewDate | calendarDate : view + 'ViewTitle' : 'en' }}</h3>
                    </div>
                    <div class="col-md-2 cal-hed-third">
                      <div
                        class="cursor"
                        mwlCalendarNextView
                        [view]="view"
                        [(viewDate)]="viewDate"
                        (viewDateChange)="closeOpenMonthViewDay()"
                      >
                        <img src="./assets/images/next.png" class="img-fluid pre-next" />
                      </div>
                    </div>
                  </div>
                  <div [ngSwitch]="view">
                    <mwl-calendar-month-view
                      *ngSwitchCase="CalendarView.Month"
                      [viewDate]="viewDate"
                      [weekStartsOn]="1"
                      [events]="events"
                      [refresh]="refresh"
                      (eventClicked)="openEventDetailsPopup($event)"
                      [activeDayIsOpen]="activeDayIsOpen"
                    >
                    </mwl-calendar-month-view>
                  </div>
                  <div class="legend">
                    <div class="legend-item">
                      <span class="legend-color" style="background-color: #1e90ff"></span>
                      Activity
                    </div>
                    <div class="legend-item">
                      <span class="legend-color" style="background-color: #e3bc08"></span>
                      Events
                    </div>
                    <div class="legend-item">
                      <span class="legend-color" style="background-color: #ad2121"></span>
                      GB
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-12 px-0 mb-3">
                  <div class="ps-3">
                    <div class="row g-2 dsbrd-rgtbox">
                      <div class="col-12 cursor">
                        <div class="p-3 text-white" [routerLink]="ACTIVITY_DASHBOARD">Go to Activity Board</div>
                      </div>
                      <div class="col-12 cursor">
                        <div class="p-3 text-white" [routerLink]="QUERY_DASHBOARD">Go to Queries</div>
                      </div>
                      <div class="col-12 cursor">
                        <div class="p-3 text-white" [routerLink]="VIEW_INFO">View My info</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div
  class="modal fade"
  id="view-notification-modal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  *ngIf="dashboard.displayAnnouncementModel.show"
>
  <div class="side-nav">
    <mat-card>
      <mat-card-header>
        <div class="row mx-0 py-2">
          <div class="col-lg-12 p-2 mb-3">
            <img
              src="../../../assets/images/svg/modal-cross.svg"
              class="close-icon"
              (click)="closeAnnouncementPopup()"
            />
            <img src="../../../assets/images/svg/notification-icon.svg" class="notification-icon" />
            <span class="heading-cnt">Announcements</span>
          </div>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div>
          <p class="heading">{{ dashboard.displayAnnouncementModel.title }}</p>
        </div>
        <div>
          <p class="description" [innerHTML]="dashboard.displayAnnouncementModel.content"></p>
        </div>
        <div class="notification-pdf" *ngIf="dashboard.displayAnnouncementModel.isAttachmentDocumentAvailable">
          <div class="d-flex" *ngFor="let attachment of dashboard.displayAnnouncementModel.attachments">
            <img src="assets/images/svg/Shape.svg " class="notification-pdficon" />
            <a (click)="downloadDocument(attachment, dashboard.displayAnnouncementModel.companyId)" class="pdf-link">{{
              attachment.name
            }}</a>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div
  class="modal fade"
  id="view-notification-modal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  *ngIf="dashboard.displayCalendarModel.show"
>
  <div class="side-nav">
    <mat-card>
      <mat-card-header>
        <div class="row py-2">
          <div class="col-lg-12 p-2 mb-3">
            <img src="../../../assets/images/svg/modal-cross.svg" class="close-icon" (click)="closeCalendarPopup()" />
            <img src="../../../assets/images/svg/calendar-icon.svg" class="calendar-icon" />
            <span class="heading-calendar">Calendar</span>
            <div class="row py-2">
              <div class="col-lg-12 heading-calendar">
                {{ dashboard.displayCalendarModel.date | date : 'd MMMM y' }}
              </div>
            </div>
          </div>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div>
          <p class="heading">{{ dashboard.displayCalendarModel.title }}</p>
        </div>
        <div *ngFor="let data of dashboard.displayCalendarModel.content">
          <p class="description">
            {{
              data?.displayDescription?.split(':')[0] && data?.referenceDisplayId
                ? data?.displayDescription?.split(':')[0] +
                  '(' +
                  data.referenceDisplayId +
                  ') - ' +
                  data?.displayDescription?.split(':')[1]
                : data?.displayDescription
            }}
          </p>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
